import { render, staticRenderFns } from "./CommunityPublisherDetail.vue?vue&type=template&id=3a4c2a79&scoped=true"
import script from "./CommunityPublisherDetail.vue?vue&type=script&lang=js"
export * from "./CommunityPublisherDetail.vue?vue&type=script&lang=js"
import style0 from "./CommunityPublisherDetail.vue?vue&type=style&index=0&id=3a4c2a79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4c2a79",
  null
  
)

export default component.exports